module.exports = __webpack_public_path__ + "img/20190705162740989.94db4a4c.png";